import styles from './StatusBadge.module.scss';

export type Status = 'optional' | 'required' | 'ok';

interface Props {
  status: Status;
}

const textByStatus = {
  optional: '任意',
  required: '必須',
  ok: 'OK',
};

const StatusBadge: React.FC<Props> = ({ status }) => (
  <span className={styles.badge} role="status" data-status={status}>
    {textByStatus[status]}
  </span>
);

export default StatusBadge;
